import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import ThreadCard from '../../frontend/community/shared/ThreadCard';
import { FaShieldAlt, FaPlus } from 'react-icons/fa';
// Ensure we use the dashboard CSS if needed, or import the frontend community CSS
import '../../frontend/community/Community.css'; 

export default function VerifiedOperatorForum() {
  const { currentUser, token } = useAuth();
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryId, setCategoryId] = useState(null);

  useEffect(() => {
    const fetchPrivateForum = async () => {
      try {
        setLoading(true);
        // 1. Get the private category ID
        const catRes = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/categories`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const catData = await catRes.json();
        
        let privateCatId = null;
        if (catData.success) {
          const privateCat = catData.categories.find(c => c.slug === 'verified-operators' || c.isPrivate);
          if (privateCat) {
            privateCatId = privateCat.id;
            setCategoryId(privateCat.id);
          }
        }

        // 2. Fetch threads for it
        if (privateCatId) {
          const threadRes = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/discussions?communityId=${privateCatId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          const threadData = await threadRes.json();
          if (threadData.success) {
            setThreads(threadData.discussions);
          }
        }
      } catch (error) {
        console.error("Error fetching private forum", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivateForum();
  }, [token]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  return (
    <div className="py-4 community-dashboard-container">
      <Row className="mb-4 align-items-center">
        <Col md={8}>
          <h2 className="mb-1 d-flex align-items-center gap-2">
            <FaShieldAlt className="text-warning" /> Verified Operator Forum
          </h2>
          <p className="text-muted mb-0">Private discussion space for approved BBR operators.</p>
        </Col>
        <Col md={4} className="text-md-end mt-3 mt-md-0">
          {categoryId && (
            <Link to={`/community/new?c=${categoryId}`} className="btn btn-warning fw-bold">
              <FaPlus className="me-2" /> New Topic
            </Link>
          )}
        </Col>
      </Row>

      <Card className="shadow-sm border-0 bg-dark text-white">
        <Card.Body className="p-0">
          {threads.length > 0 ? (
            <div className="community-container" style={{ minHeight: 'auto', padding: '10px' }}>
              {threads.map(thread => (
                <ThreadCard key={thread.id} thread={thread} />
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <h5 className="text-muted mb-3">No discussions yet in the private forum.</h5>
              <p className="text-muted mb-0">Start sharing tips, asking questions, or discussing operator best practices.</p>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
